import { render, staticRenderFns } from "./TeacherEnrollmentDialog.vue?vue&type=template&id=ce1022f2"
import script from "./TeacherEnrollmentDialog.vue?vue&type=script&lang=js"
export * from "./TeacherEnrollmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports